export default ({...props}) => {
  const {space, size, themeGrey} = props.theme
  return `
        margin-top: ${space(1.75)}px;
        &[ap_atom_name="orderDetailAtom"] > p {
            text-transform: none;
            margin-bottom: 0px;
        }

        & > .MuiBox-root {
            display: flex;
            gap: 5px; 
            
            & > p {
                text-transform: none;
                margin-bottom: 0px;
            }
        }

        & > .error-wrapper {
            flex-flow: column;
            align-items: center;
            margin-top: ${space(3)}px;

            @media screen and (max-width: 480px) {
                padding-top: ${space(3)}px;
                border-top: 1px solid ${themeGrey.border_grey};
            }

            & > div.MuiBox-root {
                max-width: ${size(62.5)}px;
                padding: ${space(3.5)}px ${space(2.5)}px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
                
                @media screen and (max-width: 480px) {
                    padding: 0;
                    box-shadow: none;
                }
                & button {
                    margin-top: ${space(5)}px;
                    width: ${size(12.5)}%;
                }
            }
        }
    `
}
